import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Stack } from 'react-bootstrap';
// import '../../Scss/Form.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import RHFTextField from '../../FunctionalComponent/FormElement/RHTextField';
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import RHSelectField from '../../FunctionalComponent/FormElement/RHSelectField';
import { useCreate_Update_sizeMutation, useGetsizeMutation } from '../../Redux/SizeSlice';
import { useDispatch, useSelector } from 'react-redux';
// import { Chip } from '@mui/material';
import Select from 'react-select';
import RHTextarea from '../../FunctionalComponent/FormElement/RHTextarea';
import { useCreate_Update_faqMutation, useFaqlistQuery } from '../../Redux/faqSlice';
import { getQueryString } from '../../lib/Validationtext';




const options = [
	{ value: 'chocolate', label: 'Chocolate' },
	{ value: 'strawberry', label: 'Strawberry' },
	{ value: 'vanilla', label: 'Vanilla' },
];

function CreateFaq(props) {
	const { setOpen, faqData, open } = props;
	console.log(faqData, "faqData");
	const [CreateUpdateFaqFunc] = useCreate_Update_faqMutation();
	const { data: listData, isLoading: listLoading } = useFaqlistQuery();

	const [GetsizeFunc] = useGetsizeMutation();
	const navigate = useNavigate();
	const dispatch = useDispatch();


	let title = {
		header: `FAQ ${faqData?.id ? 'Update' : 'Add'}`,
		submit: `${faqData?.id ? 'Update' : 'Save'}`
	};

	let initialState = {
		id: faqData?.id || '',
		question: faqData?.question || '',
		answer: faqData?.answer || '',
		status: faqData?.status || ''
	};
	console.log(initialState, "initialState");

	const schema = Yup
		.object({
			question: Yup
				.string()
				.required()
				.strict(true)
				.trim('White spaces before and after are not allow'),
			answer: Yup
				.string()
				.required()
				.strict(true)
				.trim('White spaces before and after are not allow'),
			// status: Yup.string().required(),
			// status: Yup.string().required('Status is required'),
		})
		.required();

	const methods = useForm({
		resolver: yupResolver(schema),
		defaultValues: initialState,
		mode: 'all',
	});
	const {
		handleSubmit,
		reset,
		setError,
		setValue,
		getValues,
	} = methods;

	const onSubmit = () => {
		const data = getValues();
		CreateUpdateFaqFunc({ ...data }).then(async (res) => {
			if (res?.data?.statusCode == 200) {
				// useFaqlistQuery()
				setOpen(false)
			}
		})
	}
	const handleDelete = () => {
		console.info('You clicked the delete icon.');
	};
	// useEffect(() => {
	// if (SizeData?.id) {
	//     GetsizeFunc(SizeData?.id).then(res => {
	//         const getsizedata = res?.data?.response
	//         Object.keys(initialState).forEach((fieldname) => {
	//             setValue(fieldname, getsizedata[`${fieldname}`]);
	//         })

	//     })

	// }
	// }, [SizeData?.id])

	const handleClose = () => {
		setOpen(false);
	};

	const [chips, setChips] = useState([]);
	const [chipsInput, setChipsInput] = useState('');


	return (
		<>
			<Modal id="showModal" className="fade zoomIn" size="md" title={title?.header}
				show={open} onHide={() => { setOpen(!open) }} centered>
				<Modal.Header className="px-4 pt-4" closeButton>
					<h5 className="modal-title fs-18" id="exampleModalLabel">Add FAQ</h5>
				</Modal.Header>
				<Modal.Body className="p-4">
					<FormProvider className="tablelist-form" methods={methods} onSubmit={handleSubmit(onSubmit)} >
						<Row>
							<div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
							<input type="hidden" id="id-field" />
							<Col lg={12}>
								<div className="mb-3">
									<RHFTextField name='question' label='FAQ Question' required={true} />
								</div>
							</Col>

							<Col lg={12}>
								<div className="mb-3">
									<RHTextarea label='Answer' name='answer' placeholder="Answer" rows={3} />
								</div>
							</Col>
							{/* <Col lg={12} >
                                <div className="mb-3">
                                    <RHSelectField
                                        name='status'
                                        label='Status'
                                        required={true}
                                        list={[
                                            { name: 'Active', value: true },
                                            { name: 'Inactive', value: false },
                                        ]}
                                    />
                                </div>
                            </Col> */}
							<Col lg={12} className="modal-footer">
								<div className="hstack gap-2 justify-content-end">
									<Button className="btn-ghost-danger" onClick={() => { setOpen(!open) }}><i className="ri-close-line align-bottom me-1"></i> Close</Button>
									<Button variant='primary' id="add-btn" type="submit">{title?.submit}</Button>
								</div>
							</Col>


						</Row>
					</FormProvider>
				</Modal.Body>
			</Modal>
		</>
	);
}

export default CreateFaq;
